"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsageStatisticsContainerComponent = UsageStatisticsContainerComponent;
const React = __importStar(require("react"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const GraphQLQuery = __importStar(require("@genesys/client-core/lib/graphql-query"));
const UsageStatisticsComponent = __importStar(require("./components/usage-statistics-component"));
const Actions = __importStar(require("./actions"));
const queryProduct = (0, graphql_tag_1.default) `
  query UsageStatisticsContainerComponentProduct {
    product {
      activeSystemTypes {
        id
        name
      }

      salesOrganisations {
        id
        name
      }

      systemStatus {
        id
        statusName
      }
    }
  }
`;
function UsageStatisticsContainerComponent(props) {
    return (React.createElement(GraphQLQuery.QueryProductSimple, { query: queryProduct, variables: {} }, ({ product: { activeSystemTypes, salesOrganisations, systemStatus } }) => {
        const { dispatch } = props;
        const toogleSalesOrganisationFilterCallback = () => dispatch(Actions.createToogleSalesOrganisationFilteringAction());
        const toogleSalesOrganisationGroupingCallback = () => dispatch(Actions.createToogleSalesOrganisationGroupingAction());
        const toogleSystemTypeFilterCallback = () => dispatch(Actions.createToogleSystemTypeFilteringAction());
        const toogleSystemTypeGroupingCallback = () => dispatch(Actions.createToogleSystemTypeGroupingAction());
        const toogleStatusFilterCallback = () => dispatch(Actions.createToogleStatusFilteringAction());
        const toogleStatusGroupingCallback = () => dispatch(Actions.createToogleStatusGroupingAction());
        const toogleDateFilterCallback = () => dispatch(Actions.createToogleDateFilteringAction());
        const toogleDateGroupingCallback = () => dispatch(Actions.createToogleDateGroupingAction());
        const toogleUserFilterCallback = () => dispatch(Actions.createToogleUserFilteringAction());
        const toogleUserGroupingCallback = () => dispatch(Actions.createToogleUserGroupingAction());
        const toogleDeletedSystemFilterCallback = () => dispatch(Actions.createToogleDeletedSystemFilteringAction());
        const toogleDeletedSystemGroupingCallback = () => dispatch(Actions.createToogleDeletedSystemGroupingAction());
        const toogleGenesysNo = () => dispatch(Actions.createToogleGenesysNoAction());
        const selectedSalesOrganisationsCallback = (ids) => dispatch(Actions.createSelectedSalesOrganisationsAction(ids));
        const selectedSystemTypesCallback = (ids) => dispatch(Actions.createSelectedSystemTypesAction(ids));
        const selectedStatusCallback = (ids) => dispatch(Actions.createSelectedStatusAction(ids));
        const selectedDateStartCallback = (date) => dispatch(Actions.createSelectedDateStartAction(date));
        const selectedDateEndCallback = (date) => dispatch(Actions.createSelectedDateEndAction(date));
        const selectedUsernameCallback = (username) => dispatch(Actions.createSelectedUsernameAction(username));
        const selectedDeletedSystemCallback = (ids) => dispatch(Actions.createSelectDeletedSystemsAction(ids));
        const systemTypes = activeSystemTypes.map(st => ({
            id: st.id,
            name: st.name,
            __typename: st.__typename
        }));
        const searchCallback = () => {
            dispatch(Actions.createShowResultsAction());
        };
        const canSearch = searchableState(props);
        return (React.createElement(UsageStatisticsComponent.UsageStatisticsComponent, { salesOrganisationFilter: props.uiSelection.salesOrganisationFiltering, salesOrganisationGroup: props.uiSelection.salesOrganisationGrouping, toogleSalesOrganisationFilteringCallback: toogleSalesOrganisationFilterCallback, toogleSalesOrganisationGroupingCallback: toogleSalesOrganisationGroupingCallback, systemTypeFilter: props.uiSelection.systemTypeFiltering, systemTypeGroup: props.uiSelection.systemTypeGrouping, toogleSystemTypeFilteringCallback: toogleSystemTypeFilterCallback, toogleSystemTypeGroupingCallback: toogleSystemTypeGroupingCallback, statusFilter: props.uiSelection.statusFiltering, statusGroup: props.uiSelection.statusGrouping, toogleStatusFilteringCallback: toogleStatusFilterCallback, toogleStatusGroupingCallback: toogleStatusGroupingCallback, dateFilter: props.uiSelection.dateRangeFiltering, dateGroup: props.uiSelection.dateRangeGrouping, toogleDateFilteringCallback: toogleDateFilterCallback, toogleDateGroupingCallback: toogleDateGroupingCallback, usernameFilter: props.uiSelection.usernameFiltering, usernameGroup: props.uiSelection.usernameGrouping, toogleUsernameFilteringCallback: toogleUserFilterCallback, toogleUsernameGroupingCallback: toogleUserGroupingCallback, deletedSystemFilter: props.uiSelection.deletedSystemFiltering, deletedSystemGroup: props.uiSelection.deletedSystemGrouping, toogleDeletedSystemFilteringCallback: toogleDeletedSystemFilterCallback, toogleDeletedSystemGroupingCallback: toogleDeletedSystemGroupingCallback, genesysNo: props.uiSelection.genesysNoShow, toogleGenesysNoCallback: toogleGenesysNo, salesOrganisations: salesOrganisations, systemTypes: systemTypes, status: systemStatus, selectedSalesOrganisationsCallback: selectedSalesOrganisationsCallback, selectedSystemTypesCallback: selectedSystemTypesCallback, selectedStatusCallback: selectedStatusCallback, selectedSalesOrganisations: props.uiSelection.selectedSalesOrganisations, selectedSystemTypes: props.uiSelection.selectedSystemTypes, selectedStatus: props.uiSelection.selectedStatus, selectedDateStart: props.uiSelection.selectedDateStartString, selectedDateStartCallback: selectedDateStartCallback, selectedDateEnd: props.uiSelection.selectedDateEndString, selectedDateEndCallback: selectedDateEndCallback, selectedUsername: props.uiSelection.selectedUsername, selectedUsernameCallback: selectedUsernameCallback, deletedSystems: props.uiSelection.selectedDeletedSystems, selectedDeletedSystemsCallback: selectedDeletedSystemCallback, canSearch: canSearch, searchCallback: searchCallback, showResults: props.showResults, searchOptions: props.searchSelection }));
    }));
}
function searchableState(props) {
    if (props.uiSelection.salesOrganisationFiltering &&
        props.uiSelection.selectedSalesOrganisations.length === 0) {
        return false;
    }
    if (props.uiSelection.systemTypeFiltering &&
        props.uiSelection.selectedSystemTypes.length === 0) {
        return false;
    }
    if (props.uiSelection.statusFiltering &&
        props.uiSelection.selectedStatus.length === 0) {
        return false;
    }
    if (props.uiSelection.deletedSystemFiltering &&
        props.uiSelection.selectedDeletedSystems.length === 0) {
        return false;
    }
    if (props.uiSelection.dateRangeFiltering &&
        (props.uiSelection.selectedDateRange.start === undefined ||
            props.uiSelection.selectedDateRange.end === undefined)) {
        return false;
    }
    return true;
}
//# sourceMappingURL=container-component.js.map